<template>
  <v-container class=" pa-0">
    <v-row dense>
      <v-col >
        <v-select
          v-model="item.marcaID"
          :items="Marcas"
          dense
          filled
          item-text="marca"
          item-value="marcaID"
          label="Marca"
          ref="marca"
          append-icon="fa fa-angle-down "
          class="caption"
          menu-props="auto"
        />
      </v-col>
      <v-col cols=2>
        <v-text-field 
          v-model="item.dto1"
          label="Dto 1" 
          dense
          ref="dto1"
          filled
          class="caption"
          type="number"
          autocomplete="off"
        />
      </v-col>
      <v-col cols=2>
        <v-text-field 
          v-model="item.dto2"
          label="Dto 2" 
          dense
          ref="dto2"
          filled
          class="caption"
          type="number"
          autocomplete="off"
        />
      </v-col>
      <v-col cols=2>
        <v-text-field 
          v-model="item.dto3"
          label="Dto 3" 
          dense
          ref="dto3"
          filled
          class="caption"
          type="number"
          autocomplete="off"
        />
      </v-col>
      <v-col cols=1 class="d-flex justify-center"> 
        <v-btn
          ref="add" 
          x-small 
          class="my-3 mx-0" 
          fab 
          color="primary" 
          @click="addItem" 
          :disabled="!ValidaForm"
        >
          <v-icon dense>fa fa-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense class="px-0">
      <v-col cols=12 >
        <v-data-table
          :headers="headers"
          :items="Items"
          class="elevation-1"
          hide-default-header
          hide-default-footer
          disable-pagination
          dense
          :mobile-breakpoint=100
        >
          <template v-slot:header="{props}">
            <tr>
                <td
                  v-for="header in props.headers"
                  :key="header.text"
                  class="text-truncate caption font-weight-medium px-4"
                  :class="header.class "
                  :align="header.align"
                  :width="header.width"
                >{{ header.text }}
                </td>
            </tr>
          </template>

          <template v-slot:item="{item,headers} ">
            <tr class="caption">
              <template v-for="(h, idx) in headers" >
                <td v-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                <td v-else :align="h.align" :key="idx" :class="['caption', h.class]">
                  <v-icon
                    small
                    class="mx-3"
                    @click="editItem(item)"
                  >
                    fa fa-pencil
                  </v-icon>
                  <v-icon
                    small
                    class="mx-3"
                    @click="deleteItem(item)"
                  >
                    fa fa-trash-o
                  </v-icon>
                </td>
              </template> 
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'UsuarioMarcas',
  components: {
    
	},
	props: ['items'],

  data: () => ({
    marcas:[],

		headers: [
			{ text: 'Marca', align: 'start', sortable: false, value: 'marca' },
			{ text: 'Dto 1', align: 'end', sortable: false, value: 'dto1'},
			{ text: 'Dto 2', align: 'end', sortable: false, value: 'dto2'},
			{ text: 'Dto 3', align: 'end', sortable: false, value: 'dto3'},
			{ text: ''     , align: 'end', sortable: false, value: 'actions', width:"120px" },
		],

    default:{dtoID:0, marcaID:0, marca:'', dto1:0, dto2:0, dto3:0, action:'I'},

		item:{dtoID:0, marcaID:0, marca:'', dto1:0, dto2:0, dto3:0, action:'I'},

		editedIndex:-1,

		//FIN TABLE
  }),

  created: function () {
    console.log("Componente creado")
    this.initialize()
  },
  mounted: function () {
    console.log("Componente mondado")
    //this.loadItems()
  },

  computed: {
    ...mapGetters(['SESSION','ROOT_API']),

    Items () {
      console.log('ITEMS-->',this.items)
      return this.items.filter( s => s.action!='D')
    },

    Marcas () {
      let marcas = this.marcas.map(m => {
        m.disabled = this.items.findIndex(el => el.marcaID==m.marcaID && el.action!='D') == -1 ? false : true
        return m
      })
      return marcas
    },

    ValidaForm () {
      //console.log(this.item.marcaID && this.item.dto1 > 0)
      return (this.item.marcaID && (this.item.dto1 > 0 ||  this.item.dto2 > 0 || this.item.dto3 > 0))
    }
  },

  methods :{

		initialize(){
			this.clearFrm()
      this.loadMarcas()

 			//this.items=[],
			this.item=Object.assign({},this.default)
		},


		clearFrm(){
      this.item=Object.assign({},this.default)
			this.editedIndex=-1

		//	this.$nextTick(()=>{this.$refs.numero.$refs.input.focus()})
		},

		editItem(i){
			console.log("-->",i)
      this.editedIndex = this.items.indexOf(i)
      this.item=Object.assign({},i)
      /*
			this.$nextTick( () => {
				this.$refs.importe.$refs.input.select()
				this.$refs.importe.$refs.input.focus()
			})
      */
		}, 

	  deleteItem (i){
			let index = this.items.indexOf(i)
			let remove = confirm('Esta seguro que quiere quitar el item?') 
      if (remove) {
        this.clearFrm()

        this.items[index].action=='I' ? this.items.splice(index, 1) : this.items[index].action='D'

        console.log(this.items)
      } 
						
    },
    
    addItem(){
      this.item.marca=this.marcas[this.marcas.findIndex(m => m.marcaID==this.item.marcaID)].marca
      this.editedIndex>=0 ? Object.assign(this.items[this.editedIndex], this.item):this.items.push(this.item)
      console.log("item --> ", this.item)
			this.clearFrm()
    },

    async loadMarcas (){
      let opt={
          method: 'GET', 
          mode: 'cors'
        }
      let response = await fetch(`${this.ROOT_API}cms/marcas`, opt);

      if (response.ok){
        let r=await response.json()
        this.marcas=r.map(item => {
          return {
            marcaID:item.id,
            marca:item.marca.toUpperCase(),
            disabled:false
          }
        })
        //console.log("items --> ",this.items)
      }
    },

  },
}
</script>
<style lang="scss" scoped>

</style>